import {router} from "@inertiajs/vue3";

export default {
	accepted: false,

	mounted() {
		window.addEventListener('beforeunload', this.beforeWindowUnload);
		this.removeBeforeEventListener = router.on('before', this.handleBeforeRouteLeave);
	},

	beforeUnmount() {
		window.removeEventListener('beforeunload', this.beforeWindowUnload);
		this.removeBeforeEventListener(); // Het unsetten van een inertia router event.
	},

	methods: {
		// Deze kan worden overschreven om het juiste formulier terug te geven
		getForm() {
			return this.form;
		},

		beforeWindowUnload(event) {
			if (this.getForm().isDirty) {
				event.preventDefault()
				event.returnValue = ''
			}
		},

		async handleBeforeRouteLeave(event) {
			let form = this.getForm();
			let isDirty = form.isDirty;

			if (this.accepted || !form.isDirty) {
				return true;
			}

			event.preventDefault();
			if (await Helpers.Alert.confirm('Deze pagina vraagt u om te bevestigen dat u deze wilt verlaten. Gegevens die u hebt ingevoerd worden mogelijk niet opgeslagen.')) {
				this.accepted = true;
				let action = Object.keys(event.detail)[0];
				let object = event.detail[action];
				router[action](object.url, object);
			}
		}
	}
}
